export default class ProductPage {
    constructor() {
        const imageElement = document.getElementById('product-images');
        const placementElement = document.querySelector('.product-detail__description');
        if (window.innerWidth < 768) {
          placementElement.parentNode.insertBefore(imageElement, placementElement);
          imageElement.classList.add('initialized');
        }
    }
}
